<template>
    <v-select
        :items     = "items"
        item-value = "id"
        item-text  = "name"
        :label     = "label"
        v-model    = "selected"
        @change    = "onChange"
        :rules     = "rules"
        :readonly  = "readonly"
        :disabled  = "readonly"
        :clearable = "clearable"
    />
</template>

<script>
export default {
    name : "InbInvoiceTypes",
    props: {
        value: {
            required: true
        },
        label: {
            required: true
        },
        rules: {

        },
        readonly: {
            required: false,
            type    : Boolean,
            default : function () {
                return false;
            }
        },
        clearable: {
            required: false,
            type    : Boolean,
            default : function () {
                return true;
            }
        }
    },

    data: () => ({
        selected: null
    }),

    computed: {
        items () {
            return this.$store.getters.invoiceTypes;
        }
    },

    mounted() {
        this.selected = this.value;
    },

    watch: {
        value () {
            this.selected = this.value;
        }
    },

    methods: {
        onChange () {
            let item = this.items.find (item => item.id === this.selected);
            this.$emit('input', item);
            this.$emit('change', item);
        }
    }
}
</script>

<style scoped>

</style>